import React from 'react';
import useInView from '../hooks/useInView';

const skills = [
  { category: 'Frontend', items: ['React', 'TypeScript', 'Tailwind CSS', 'Next.js', 'Electron'] },
  { category: 'Backend', items: ['Node.js', 'Express', 'Python', 'Java', 'FastAPI'] },
  { category: 'Database', items: ['MySQL', 'Prisma'] },
  { category: 'Tools / DevOps', items: ['Git', 'Docker', 'Linux'] },
];

const Skills = () => {
  const [ref, inView] = useInView();

  return (
    <section id="skills" className="py-20 md:py-32 px-6 md:px-12 max-w-6xl mx-auto border-t border-neutral-200 dark:border-white/10">
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
      >
        <div className="md:col-span-4">
          <h2 className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-4">
            02 / Skills
          </h2>
          <div className="h-px bg-neutral-200 dark:bg-white/20 w-12 hidden md:block"></div>
        </div>
        <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-8 md:gap-y-10 mt-4 md:mt-0">
          {skills.map((skillGroup, idx) => (
            <div key={idx} className="space-y-4 border-l-2 border-neutral-200 dark:border-white/10 pl-4 md:pl-6">
              <h3 className="text-neutral-900 dark:text-white font-medium tracking-wide">
                {skillGroup.category}
              </h3>
              <ul className="space-y-2">
                {skillGroup.items.map((item, i) => (
                  <li key={i} className="text-neutral-600 dark:text-neutral-400 font-mono text-sm">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
